import { useTranslation } from 'react-i18next';
import { Button, Drawer } from '@/components';
import { OpportunityDetails } from '../../../types';
import { AboutSellerFormNew } from './about-seller-form-new';

export type PermitsDrawerProps = {
  readonly opportunity: OpportunityDetails;
  readonly onSubmit: (item: any, description?: string) => void;
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly formId: string;
};

export function AboutSellerNewDrawer({ opportunity, onSubmit, onClose, isOpen, formId }: PermitsDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('About the seller')} open={isOpen} onClose={onClose} footer={footer}>
      <AboutSellerFormNew
        id={formId}
        opportunity={opportunity}
        onSubmit={(data: any) => {
          onSubmit(data, t('About the seller section has been updated'));
        }}
      />
    </Drawer>
  );
}
